import React, { useState } from 'react';
import { withTranslation } from 'react-i18next';
import { Button } from 'react-bootstrap';
import { BiX } from "react-icons/bi";

const CustomTopicFilter = ({ t, showOwnTopicsOnly, onFilterHide, onApplyFilter }) => {
    const [filterType, setFilterType] = useState(showOwnTopicsOnly ? 'custom' : 'all');

    const handleFilterTypeChange = (type) => {
        setFilterType(type);
    };

    const applyFilter = () => {
        const filterData = {
            showOwnTopicsOnly: filterType === 'custom'
        };
        onApplyFilter(filterData);
        onFilterHide(false);
    };

    const resetFilter = () => {
        setFilterType('all');
        const filterData = {
            showOwnTopicsOnly: false
        };
        onApplyFilter(filterData);
    };

    return (
        <div className="MaterialIssuesLibrary_filter Main_filter 1">
            <div className="Main_filter_head">
                <h5>{t("Filter.label")}</h5>
                <div 
                    className="btnClose" 
                    onClick={() => onFilterHide(false)}
                   >
                    <BiX />
                </div>
            </div>
            <div className="Main_filter_body">
                <div className="row m-0">
                    <div className="col-12 p-2">
                        <label className="mb-2">{t("TopicType.label")}</label>
                        <div className="DataType_box002">
                            <div className="DataTypeCheck">
                                <input
                                    className="form-check-input"
                                    type="radio"
                                    name="topicType"
                                    id="allTopics"
                                    value="all"
                                    checked={filterType === 'all'}
                                    onChange={(e) => handleFilterTypeChange(e.target.value)}
                                />
                                <label htmlFor="allTopics">
                                    {t("AllTopics.label")}
                                </label>
                            </div>
                            <div className="DataTypeCheck">
                                <input
                                    className="form-check-input"
                                    type="radio"
                                    name="topicType"
                                    id="customTopics"
                                    value="custom"
                                    checked={filterType === 'custom'}
                                    onChange={(e) => handleFilterTypeChange(e.target.value)}
                                />
                                <label htmlFor="customTopics">
                                    {t("CustomTopics.label")}
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="Main_filter_footer p-2 pb-3 text-center">
                <Button variant="primary"
                    onClick={() => applyFilter()}
                    className="sbmBtn px-4">
                    {t("Apply.label")}
                </Button>
                <Button variant="secondary"
                    onClick={() => resetFilter()}
                    className="px-4 mx-2">
                    {t("Reset.label")}
                </Button>
            </div>
        </div>
    );
};

export default withTranslation()(CustomTopicFilter);
